import { publicRequest } from '@/core';
import { incoterms } from '@/requests';

export default async function getFilteredGlobalUniquePostalPlacesRequest(filterString) {

	let url = incoterms.getFilteredGlobalPostalPlacesPath();
	try {
		let response = await publicRequest({
			url,
			method: 'get',
			params: {
				filterString,
				unique: true
			}
		});
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
